module.exports = __webpack_public_path__ + "static/media/logo-suntec-white.d2bed340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-suntec-white.png
// module id = 274
// module chunks = 0